export default __webpack_public_path__ + "static/media/information-tag-icon.031ca52e.svg";